// @format

import { showNotice } from "../../notice";
import { syncRowFollowup } from "../../candidate_row_sync";

export function initCandidatesFollowup(): void {
  const csrf = (): string =>
    (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null)?.content || "";

  const root = (): HTMLElement | null => document.querySelector<HTMLElement>("[data-followup]");

  type FuState = "empty" | "editor" | "saved";
  const setState = (state: FuState): void => {
    const r = root();
    if (!r) return;
    const toggle = (sel: string, on: boolean): void => {
      const el = r.querySelector<HTMLElement>(sel);
      if (el) el.style.display = on ? "" : "none";
    };
    toggle("[data-fu-empty]", state === "empty");
    toggle("[data-fu-editor]", state === "editor");
    toggle("[data-fu-saved]", state === "saved");
    const open = document.querySelector<HTMLElement>("[data-fu-open]");
    if (open) open.style.display = state === "editor" ? "none" : "";
  };

  const restingState = (): FuState => (root()?.getAttribute("data-has-followup") === "true" ? "saved" : "empty");

  const ensureEditor = (): void => {
    const r = root();
    if (!r) return;
    const el = $(r).find("[data-fu-text]");
    if (!el.length || el.next(".note-editor").length) return;
    el.summernote({
      dialogsInBody: true,
      minHeight: 200,
      fontNames: ["Arial", "Helvetica", "Times New Roman", "Verdana"],
      toolbar: [
        ["style", ["bold", "italic", "underline"]],
        ["font", ["fontname", "fontsize", "color"]],
        ["insert", ["link"]],
        ["misc", ["codeview"]],
      ],
    });
  };

  $(document).off("click.fu", "[data-fu-open], [data-fu-edit]").on("click.fu", "[data-fu-open], [data-fu-edit]", () => {
    setState("editor");
    ensureEditor();
    // scroll the drawer body down to reveal the editor (+ its actions); the
    // timeout lets summernote finish laying out before we read scrollHeight.
    const body = root()?.closest<HTMLElement>(".drawer-body");
    if (body) window.setTimeout(() => body.scrollTo({ top: body.scrollHeight, behavior: "smooth" }), 60);
  });
  $(document).off("click.fu", "[data-fu-cancel]").on("click.fu", "[data-fu-cancel]", () => setState(restingState()));

  const save = (schedule: boolean): void => {
    const r = root();
    if (!r) return;
    const url = r.getAttribute("data-followup-url") || "";
    const $text = $(r).find("[data-fu-text]");
    const text = $text.next(".note-editor").length ? String($text.summernote("code") || "") : String($text.val() || "");
    const date = r.querySelector<HTMLInputElement>("[data-fu-date]")?.value || "";
    if (schedule && !date) {
      showNotice("Pick a date to schedule the follow-up.", "danger");
      return;
    }

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": csrf(), Accept: "application/json" },
      body: JSON.stringify({
        email_chain: {
          scheduled_auto_response_follow_up_at: schedule ? date : "",
          follow_up_subject: "Following up",
          follow_up_body: text,
        },
      }),
    })
      .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
      .then((data) => {
        // make_follow_upable rescues errors as { alert } with a 200, so check the body
        if (data && data.alert) {
          showNotice("Could not save the follow-up. Please try again.", "danger");
          return;
        }
        const savedText = r.querySelector<HTMLElement>("[data-fu-saved-text]");
        if (savedText) savedText.innerHTML = text;
        // the saved card reads blue for an unscheduled draft, green once it has a date
        const scheduled = Boolean(schedule && date);
        r.querySelector<HTMLElement>("[data-fu-saved]")?.classList.toggle("fu-scheduled", scheduled);
        const savedTitle = r.querySelector<HTMLElement>("[data-fu-saved-title]");
        if (savedTitle) savedTitle.textContent = scheduled ? "Follow-up scheduled" : "Follow-up draft saved";
        const when = r.querySelector<HTMLElement>("[data-fu-when]");
        const whenDate = r.querySelector<HTMLElement>("[data-fu-when-date]");
        if (schedule && date && when && whenDate) {
          whenDate.textContent = new Date(`${date}T00:00:00`).toLocaleDateString(undefined, {
            day: "numeric",
            month: "short",
            year: "numeric",
          });
          when.style.display = "";
        } else if (when) {
          when.style.display = "none";
        }
        r.setAttribute("data-has-followup", "true");

        syncRowFollowup(
          r.getAttribute("data-email-chain-id") || "",
          schedule && date ? date : null,
          text.trim().length > 0,
        );
        setState("saved");
        showNotice(schedule ? "Follow-up scheduled." : "Follow-up draft saved.", "success");
      })
      .catch(() => showNotice("Could not save the follow-up. Please try again.", "danger"));
  };

  $(document).off("click.fu", "[data-fu-schedule]").on("click.fu", "[data-fu-schedule]", () => save(true));
  $(document).off("click.fu", "[data-fu-save]").on("click.fu", "[data-fu-save]", () => save(false));
}
